import { motion } from 'framer-motion';

const stats = [
  { value: '150+', label: 'Guidewire Projects' },
  { value: '50+', label: 'Insurance Clients' },
  { value: '500+', label: 'Certified Experts' },
  { value: '15+', label: 'Years Experience' },
];

export const Stats = ({ data = stats, className = '' }) => {
  return (
    <div className={`grid grid-cols-2 lg:grid-cols-4 gap-8 ${className}`}>
      {data.map((stat, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          className="text-center"
          data-testid={`stat-${index}`}
        >
          <div className="text-4xl lg:text-5xl font-bold text-slate-900 dark:text-white mb-2">
            {stat.value}
          </div>
          <div className="text-sm text-slate-600 dark:text-slate-400 font-medium">
            {stat.label}
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export const StatsBar = ({ data = stats, className = '' }) => {
  return (
    <div className={`bg-slate-900 dark:bg-slate-800 rounded-2xl p-8 lg:p-12 ${className}`}>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
        {data.map((stat, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="text-center"
          >
            <div className="text-3xl lg:text-4xl font-bold text-white mb-2">
              {stat.value}
            </div>
            <div className="text-sm text-slate-400 font-medium">
              {stat.label}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};
